<template>
  <div>
    <b-button
      class="rounded-circle d-flex align-items-center justify-content-center p-0 querybuilder-action-button mx-1"
      variant="outline-danger"
      :id="`popover-remove-group-btn-${id}`"
    >
      <font-awesome-icon icon="times"></font-awesome-icon>
    </b-button>
    <b-popover :target="`popover-remove-group-btn-${id}`" boundary="viewport" variant="danger" triggers="click blur" placement="top">
      <span @click="onGroupRemove" class="clickable">
        Haz click aquí para eliminar
      </span>
    </b-popover>
  </div>
</template>

<script>
import LmButton from '@/components/form/elements/LmButton'

export default {
  components: {
    LmButton
  },
  props: {
    nodes: Array,
    id: [Number, String]
  },
  methods: {
    onGroupRemove () {
      this.$root.$emit('bv::hide::popover')
      this.$emit('group-remove', this.id)
    }
  }
}
</script>

<style scoped>
  .querybuilder-action-button {
    width: 25px;
    height: 25px;
  }
</style>
